<template>
  <el-dialog title="Editar Contato Realizado" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="25%">
        <el-form :model="contato" :rules="validacao" ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false">
          <el-row :gutter="24">
            <el-col :span="14">
              <el-form-item class="form-item" label="Data/Hora de Retorno" prop="dataProximoContato">
                <el-date-picker
                  v-model="contato.dataProximoContato"
                  v-mask="'##/##/#### ##:##'"
                  type="datetime"
                  format="dd/MM/yyyy HH:mm"
                  value-format="dd/MM/yyyy HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer">
          <el-button @click="fechar" round class="btn-box-shadow">Fechar</el-button>
          <el-button @click="gravar" type="primary" round class="btn-box-shadow">Confirmar</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { validadorDataHora } from '../../../util/validadores.js'

export default {
  props: {
    contato: Object,
    visibility: Boolean
  },
  data() {
    return {
      validacao: {
        dataProximoContato: [
          { validator: validadorDataHora, trigger: 'blur' },
        ]
      },
      //dataProximoContato: ""
    }
  },
  computed: {
    ...mapState('vendasClientesStore', {
      cliente(state) { return state.clienteSelecionado }
    })
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
  ...mapActions('vendasClientesStore', [
      'usuariosDisponiveis',
      'atualizarContatoRealizado'
    ]),

    gravar(){
      this.$refs['form'].validate((valid) => {
        if(valid){
          this.contato.cliente = { id: this.cliente.id };
          this.showLoading();
          this.atualizarContatoRealizado(this.contato).then((response) => {
            this.hideLoading();
            switch(response.status) {
              case "SUCESSO":
                this.console.log(response);
                this.contato = { id: 0 };
                this.$message.success(response.mensagem);
                this.fechar();
                break;
              case "FALHA":
                this.$message.warning(response.mensagem);
                break;
              case "ERRO":
                this.$message.error(response.mensagem);
                break;
            }
          }).catch(() => {
            this.hideLoading();
          });
          this.$emit('close');
        }
      })
    },
    fechar() {
      this.$emit('close');
    }    
  }
}
</script>
